import { Search } from 'lucide-react';
import { Input } from '@/shared/ui/input/input';

type SearchInputProps = {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder: string;
};

export function SearchInput({ value, onChange, placeholder }: SearchInputProps) {
  return (
    <div className="relative min-w-48 flex-1">
      <Search className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        placeholder={placeholder}
        aria-label={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-10 pl-9 text-base md:text-sm"
      />
    </div>
  );
}
